var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCallWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_1841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.327942,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_1841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15.3279C2.5875 15.3279 2.23438 15.1811 1.94063 14.8873C1.64688 14.5936 1.5 14.2404 1.5 13.8279V4.82794C1.5 4.41544 1.64688 4.06232 1.94063 3.76857C2.23438 3.47482 2.5875 3.32794 3 3.32794H12C12.4125 3.32794 12.7656 3.47482 13.0594 3.76857C13.3531 4.06232 13.5 4.41544 13.5 4.82794V8.20294L15.8625 5.84044C15.9875 5.71544 16.125 5.68419 16.275 5.74669C16.425 5.80919 16.5 5.92794 16.5 6.10294V12.5529C16.5 12.7279 16.425 12.8467 16.275 12.9092C16.125 12.9717 15.9875 12.9404 15.8625 12.8154L13.5 10.4529V13.8279C13.5 14.2404 13.3531 14.5936 13.0594 14.8873C12.7656 15.1811 12.4125 15.3279 12 15.3279H3ZM3 13.8279H12V4.82794H3V13.8279Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallWhite);
export default __webpack_public_path__ + "static/media/video_call_white.1e5574ed45b7a700b9bf1c4798c5d7f9.svg";
export { ForwardRef as ReactComponent };